import { FilterConfig } from '../../../common/models/filter.model';
import { FILTER_ITEMS } from './constants-filter-configs';
import { GLOBAL_FILTERS } from './constants';

export const COACH_FILTER: FilterConfig[] = [
  FILTER_ITEMS.dateRange,
  FILTER_ITEMS.surveyQuestionResponse,
  ...GLOBAL_FILTERS,
  FILTER_ITEMS.categoryStatus,
  FILTER_ITEMS.alignmentChange,
  FILTER_ITEMS.channel,
  FILTER_ITEMS.interactionType,
  FILTER_ITEMS.topic,
  FILTER_ITEMS.insightSourceName,
  FILTER_ITEMS.tags,
];

export const COACH_TEAM_MEMBER_DETAILS_FILTER: FilterConfig[] = [
  FILTER_ITEMS.dateRange,
  FILTER_ITEMS.specialty,
  FILTER_ITEMS.tags,
  FILTER_ITEMS.profile,
];

export const COACH_SEGMENT_FILTER: FilterConfig[] = [FILTER_ITEMS.accountCountry];
